export type DesignRole = "administrator" | "manager" | "member" | "viewer";
export type DesignUser = { id: string; displayName: string; username: string; email: string; departmentId: string; departmentName: string | null; role: DesignRole };
export type RoleFilter = DesignRole | "all";

export function filterDesignUsers(users: DesignUser[], search: string, role: RoleFilter) {
  const query = search.trim().toLocaleLowerCase();
  return users.filter((user) => {
    const matchesRole = role === "all" || user.role === role;
    const haystack = [user.displayName, user.username, user.email, user.departmentName ?? ""].join(" ").toLocaleLowerCase();
    return matchesRole && (!query || haystack.includes(query));
  });
}
